import { render } from "./AlertsPage.vue?vue&type=template&id=141d3d14&scoped=true"
import script from "./AlertsPage.vue?vue&type=script&lang=js"
export * from "./AlertsPage.vue?vue&type=script&lang=js"

import "./AlertsPage.vue?vue&type=style&index=0&id=141d3d14&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-141d3d14"]])

export default __exports__